import { Box } from '@mui/material';

type Props = {
  children?: React.ReactNode;
};

export default function SidebarLink(props: Props): JSX.Element {
  return (
    <Box sx={{ 
        textAlign: "left",
        position: "relative",
        padding: "5px 20px 5px 50px"
      }}>
      {props.children}
    </Box>
  );
}